import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';
import { faShieldCheck } from '@fortawesome/pro-regular-svg-icons/faShieldCheck';

import { colors } from 'us-react-components/dist/constants/Styles';
import { NotificationBanner } from 'us-react-components/dist/NotificationBanner/NotificationBanner';
import { DateFormat, formatDateFromString } from 'us-react-components/dist/utils/date';
import { SitterDashboardData } from 'us-web-services';
import { useDependencies } from '../../dependencies';

interface Props {
  dashboardData: SitterDashboardData;
}

const BackgroundCheckBanner = (props: Props): JSX.Element => {
  const { services: { tracker } } = useDependencies();
  const { t } = useSharedTranslation(namespaces.caregiver);
  const { dashboardData } = props;

  const bannerProps = {
    title: 'components.backgroundCheckBanner.heading',
    color: colors.honey.DEFAULT,
    icon: faShieldCheck,
    buttonTitle: 'components.backgroundCheckBanner.buttonTitle',
    onClick: (): void => {
      const trackingProps = {
        elementId: 'background-check-warning-button',
        elementText: t('components.backgroundCheckBanner.buttonTitle'),
      };

      tracker.track('clicked-button', trackingProps);
      window.open(dashboardData.backgroundCheck?.url, '_blank', 'noreferrer');
    }
  };

  const getBody = (): JSX.Element => (
    <>
      {t('components.backgroundCheckBanner.body1')}
      <span className='font-bold'>
        {formatDateFromString(dashboardData.backgroundCheckDeadline ?? '', DateFormat.DATE_FULL_FORMAT)}
      </span>
      {t('components.backgroundCheckBanner.body2')}
      <span className='inline-block mt-3'>{t('components.backgroundCheckBanner.body3')}</span>
    </>
  );

  return (
    <div>
      {bannerProps && (<NotificationBanner
        icon={bannerProps.icon}
        title={t(bannerProps.title)}
        body={getBody()}
        color={bannerProps.color}
        buttonTitle={bannerProps.buttonTitle && t(bannerProps.buttonTitle)}
        onClick={bannerProps.onClick}
      />)}
    </div>
  );
};

export { BackgroundCheckBanner };
